import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch, toRefs } from 'vue';
import { getI18nInstance as i18n } from '@/i18n';
import { Address } from '@/models/Address';
import { User, UserCollection } from '@/models/User';
import { errToStr } from '@/helpers/tools';
import { commitToast } from '@/plugins/toast';
import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkedUserList',
  props: {
    address: null
  },
  setup(__props: any) {

const props = __props as {
    address: Address;
};


const { address } = toRefs(props);

const headers = [
    { width: 35, sortable: false, value: 'actions' },
    { text: i18n().t('username'), sortable: false, flex: 1, value: '$.username' },
    { text: i18n().t('nachname'), sortable: false, flex: 1, value: '$.lastname' },
    { text: i18n().t('vorname'), sortable: false, flex: 1, value: '$.firstname' },
    { text: i18n().t('kulturverbund'), sortable: false, flex: 1, value: '$.organizer_group' },
];

const loading = ref(true);
const collection = new UserCollection();

const filters = computed(() => {
    return [
        {
            property: 'id',
            value: address?.value?.creator_id ?? -1,
        },
    ];
});

watch(
    () => address?.value?.id,
    async (newId) => {
        await reload();
    },
);

const editRecord = (record: User) => {
    router.push({ name: 'user-edit', params: { id: record?.getId() } });
};

const reload = async () => {
    loading.value = true;
    try {
        const params = { filter: JSON.stringify(filters.value) };
        await collection.query(params);
    } catch (e) {
        commitToast({ message: errToStr(e), color: 'error' });
    } finally {
        loading.value = false;
    }
    return collection;
};

onMounted(async () => {
    await reload();
});

return { __sfc: true,props, address, headers, loading, collection, filters, editRecord, reload, i18n }
}

})